import { AppRouteProps } from "@bsm/component";
import ProjectTimeOffCreateContainer from "./container/ProjectTimeOffCreateContainer";
import { ProjectTimeOffCreateLeavingRoutes } from "./views/leaving/ProjectTimeOffCreateLeavingRoutes";
import { ProjectAppointmentCreateMissingRoutes } from "./views/missing/ProjectAppointmentCreateMissingRoutes";

export const ProjectTimeOffEventCreateEventRoutes: Array<AppRouteProps> = [
    {
        path: "leave",
        title: "BSMRH.Project.Appointment.Create.Label",
        element: <ProjectTimeOffCreateContainer />,
        children: [
            ...ProjectTimeOffCreateLeavingRoutes,
            ...ProjectAppointmentCreateMissingRoutes,
        ]
    },
];
